import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.913 2.65776C6.988 2.38776 9.103 2.24976 11.25 2.24976C13.397 2.24976 15.512 2.38876 17.587 2.65776C19.509 2.90776 20.878 4.51876 20.992 6.38476C20.6577 6.27338 20.3112 6.20254 19.96 6.17376C17.1582 5.94117 14.3418 5.94117 11.54 6.17376C9.182 6.36976 7.5 8.36376 7.5 10.6078V14.8938C7.49906 15.7175 7.72577 16.5255 8.15512 17.2286C8.58446 17.9316 9.19973 18.5024 9.933 18.8778L7.28 21.5298C7.17511 21.6345 7.04154 21.7058 6.89614 21.7347C6.75074 21.7636 6.60004 21.7488 6.46308 21.692C6.32611 21.6353 6.20903 21.5393 6.12661 21.4161C6.04419 21.2929 6.00013 21.148 6 20.9998V16.9698C5.6372 16.9312 5.27484 16.8885 4.913 16.8418C2.905 16.5798 1.5 14.8328 1.5 12.8618V6.63776C1.5 4.66776 2.905 2.91876 4.913 2.65776Z"
        fill={colorValue}
      />
      <path
        d="M15.75 7.49976C14.374 7.49976 13.011 7.55676 11.664 7.66876C10.124 7.79676 9 9.10276 9 10.6088V14.8938C9 16.4008 10.128 17.7078 11.67 17.8338C12.913 17.9358 14.17 17.9908 15.438 17.9988L18.22 20.7798C18.3249 20.8845 18.4585 20.9558 18.6039 20.9847C18.7493 21.0136 18.9 20.9988 19.0369 20.942C19.1739 20.8853 19.291 20.7893 19.3734 20.6661C19.4558 20.5429 19.4999 20.398 19.5 20.2498V17.8598L19.83 17.8338C21.372 17.7088 22.5 16.4008 22.5 14.8938V10.6078C22.5 9.10276 21.375 7.79676 19.836 7.66776C18.4769 7.55537 17.1137 7.49933 15.75 7.49976Z"
        fill={colorValue}
      />
    </svg>
  );
};
